import "./Form_Header.css";

const Form_Header = ({
  step = 1,
  totalSteps = 6,
  title = "Create Account",
  subtitle = "Get an Access to Your Pass to fitness",
  stepPrefix = "Step",
  stepSeparator = "off",
  mandatoryText = "(All Fields Mandatory)",
}) => {
  const progressWidth = (step / totalSteps) * 100;

  return (
    <div className="form_header_wrapper">
      <div className="form_header_top">
        <div>
          <h3 className="create_title">{title}</h3>
          <p className="create_subtitle">{subtitle}</p>
        </div>

        <div className="progress_line">
          <span
            className="progress_fill"
            style={{ width: `${progressWidth}%` }}
          />
        </div>

        <div className="step_text">
          <p className="steps">
            <span className="step_span">
              {stepPrefix} {step}
            </span>{" "}
            {stepSeparator} {totalSteps}
          </p>
          <p className="fields_span">{mandatoryText}</p>
        </div>

        <div className="mobile_progress_line">
          <span
            className="progress_fill"
            style={{ width: `${progressWidth}%` }}
          />
        </div>
      </div>
    </div>
  );
};

export default Form_Header;
